import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/style/themes/dashboard.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Layouts/Dashboard/DashboardToolSide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Layouts/Dashboard/Partials/DashboardSide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Layouts/Dashboard/Partials/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Layouts/Default/Partials/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Layouts/Default/Partials/Navbar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Pages/FaqCategoryDetail/index.tsx");
